import React from "react";
import { Stack, Group, Select, Button, Text, ActionIcon, Box } from "@mantine/core";
import { IconPlus, IconTrash } from "@tabler/icons";

const McaSetValuesEditor = ({ setValues = [], onChange, statusFields = [] }) => {
  const updateRow = (idx, patch) => {
    const next = setValues.map((r, i) => (i === idx ? { ...r, ...patch } : r));
    onChange(next);
  };

  const fieldDef = (fieldName) =>
    statusFields.find((f) => f.field === fieldName) ??
    (fieldName
      ? { field: fieldName, label: fieldName, options: [] }
      : null);

  const fieldSelectData = (rowField) => {
    const known = statusFields.map((f) => ({
      value: f.field,
      label: f.label,
    }));
    if (rowField && !statusFields.some((f) => f.field === rowField)) {
      known.push({ value: rowField, label: rowField });
    }
    return known;
  };

  if (!statusFields.length) {
    return (
      <Text size="xs" color="dimmed">
        Select a target entity with status fields to configure set values.
      </Text>
    );
  }

  return (
    <Stack spacing="xs" sx={{ width: "100%" }}>
      <Text size="xs" color="dimmed">
        Applied to the target entity when this step is approved.
      </Text>
      {setValues.map((row, idx) => {
        const def = fieldDef(row.field);
        const valueOptions = def?.options ?? [];
        return (
          <Group key={idx} spacing="sm" align="flex-end" noWrap sx={{ width: "100%" }}>
            <Box sx={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
              <Select
                placeholder="Status field"
                size="xs"
                sx={{ width: "100%" }}
                data={fieldSelectData(row.field)}
                value={row.field || null}
                onChange={(v) => updateRow(idx, { field: v ?? "", value: "" })}
                searchable
                clearable
              />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
              <Select
                placeholder="Value"
                size="xs"
                sx={{ width: "100%" }}
                data={valueOptions}
                value={row.value ?? ""}
                onChange={(v) => updateRow(idx, { value: v ?? "" })}
                searchable
                clearable
                disabled={!row.field}
              />
            </Box>
            <ActionIcon
              variant="subtle"
              size="sm"
              sx={{ flexShrink: 0 }}
              onClick={() => onChange(setValues.filter((_, i) => i !== idx))}
            >
              <IconTrash size={14} />
            </ActionIcon>
          </Group>
        );
      })}
      <Button
        size="xs"
        w="fit-content"
        variant="light"
        leftIcon={<IconPlus size={14} />}
        onClick={() => onChange([...setValues, { field: "", value: "" }])}
      >
        Add set value
      </Button>
    </Stack>
  );
};

export default McaSetValuesEditor;
